import React from 'react';
import Link from 'next/link';
import { IPrismicImage } from '@monofront/types';
import ResponsiveImage from '../ResponsiveImage';

interface ILogoCard {
  label?: string;
  link?: string;
  visual: IPrismicImage;
}

const LogoCard: React.FC<ILogoCard> = ({ label, link, visual }) => {
  const styledCard = (
    <div className="logo-card tw-inline-block tw-p-8 tw-border tw-border-solid tw-border-blue-200 tw-bg-white tw-rounded-3xl tw-text-center">
      <div className="img-wrapper tw-w-[82px] desktop:tw-w-[116px]">
        <ResponsiveImage
          src={visual.url}
          alt={visual.alt || label}
          width={visual.dimensions.width}
          height={visual.dimensions.height}
        />
      </div>
    </div>
  );

  if (link) {
    return <Link href={link}>{styledCard}</Link>;
  }

  return styledCard;
};

export default LogoCard;
